var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 4.08846C34.6761 4.59615 33.2354 4.96154 31.7515 5.10385C33.283 4.29231 34.4468 3.01154 34.9963 1.48846C33.5815 2.23846 31.9808 2.78846 30.3151 3.07308C28.9653 1.79231 27.0487 1 24.9244 1C20.836 1 17.5479 3.94615 17.5479 7.56154C17.5479 8.06923 17.6171 8.57692 17.7296 9.06539C11.6077 8.78077 6.14782 6.18077 2.51797 2.2C1.87766 3.17692 1.51424 4.29231 1.51424 5.51154C1.51424 7.78846 2.81649 9.79615 4.80231 10.9769C3.59091 10.9346 2.44874 10.6308 1.46665 10.1423V10.2231C1.46665 13.4115 4.00192 16.0538 7.38084 16.6615C6.76217 16.8038 6.10023 16.8846 5.43829 16.8846C4.95806 16.8846 4.50379 16.8423 4.04519 16.7846C4.97969 19.3846 7.701 21.2731 10.9415 21.3346C8.4062 23.1 5.23062 24.1385 1.78248 24.1385C1.1638 24.1385 0.592717 24.1192 0 24.0577C3.27076 25.9231 7.15154 27 11.3308 27C24.8985 27 32.3226 17.0077 32.3226 8.33462C32.3226 8.05 32.3226 7.76538 32.3009 7.48077C33.7373 6.54615 34.9963 5.38846 36 4.08846Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a0ed7e27.svg";
export { ForwardRef as ReactComponent };